import PropTypes from 'prop-types';
import { Card, RcLink } from '../../../shared';
import { timestampFormatter, trackingUrl } from '../../../transforms';

const NOT_PROVIDED = 'Not Provided';

function ProductionOrdersShowItemDetails({ productionOrder }) {
  return (
    <Card className="h-full p-4">
      <table className="w-full text-black/80">
        <thead className="sr-only text-left text-black/80 text-sm sm:not-sr-only">
          <tr>
            <th
              scope="col"
              className="pr-4 pb-1 font-bold text-black/60 text-sm"
            >
              Name
            </th>
            <th
              scope="col"
              className="hidden pr-4 pb-1 font-bold text-black/60 text-sm sm:table-cell"
            >
              Carrier
            </th>
            <th
              scope="col"
              className="hidden pr-4 pb-1 font-bold text-black/60 text-sm sm:table-cell"
            >
              Tracking Number
            </th>
            <th
              scope="col"
              className="hidden pr-4 pb-1 font-bold text-black/60 text-sm sm:table-cell"
            >
              Label URL
            </th>
            <th
              scope="col"
              className="hidden pr-4 pb-1 font-bold text-black/60 text-sm sm:table-cell"
            >
              Carrier ETA
            </th>
            <th
              scope="col"
              className="hidden pr-4 pb-1 font-bold text-black/60 text-sm sm:table-cell"
            >
              Delivered At
            </th>
            <th
              scope="col"
              className="hidden pr-4 pb-1 font-bold text-black/60 text-sm sm:table-cell"
            >
              Product
            </th>
            <th
              scope="col"
              className="hidden pr-4 pb-1 text-right font-bold text-black/60 text-sm sm:table-cell"
            >
              Quantity
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-black/20 border-black/20 border-b text-sm sm:border-t-2">
          {productionOrder.productionOrderItemsAttributes.map(
            (productionOrderItem) => (
              <tr key={productionOrderItem.id}>
                <td className="py-2 pr-4">
                  <p className="font-bold text-black">
                    {productionOrderItem.name}
                    <br />
                    {productionOrderItem.patient && (
                      <span className="font-normal text-xs capitalize">
                        (For {productionOrderItem.patient.firstName}
                        &nbsp;
                        {productionOrderItem.patient.lastName})
                      </span>
                    )}
                  </p>
                </td>
                <td className="hidden py-4 pr-4 sm:table-cell">
                  {productionOrderItem?.shippingCarrier?.name || NOT_PROVIDED}
                </td>
                <td className="hidden py-4 pr-4 sm:table-cell">
                  {productionOrderItem.trackingNumber ? (
                    <RcLink
                      href={
                        productionOrderItem.trackingUrl ||
                        trackingUrl(productionOrderItem?.trackingNumber)
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {productionOrderItem.trackingNumber}
                    </RcLink>
                  ) : (
                    NOT_PROVIDED
                  )}
                </td>
                <td className="hidden py-4 pr-4 sm:table-cell">
                  {productionOrderItem.labelUrl ? (
                    <RcLink
                      href={productionOrderItem.labelUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View
                    </RcLink>
                  ) : (
                    NOT_PROVIDED
                  )}
                </td>
                <td className="hidden py-4 pr-4 sm:table-cell">
                  {productionOrderItem.eta
                    ? timestampFormatter(productionOrderItem.eta)
                    : NOT_PROVIDED}
                </td>
                <td className="hidden py-4 pr-4 sm:table-cell">
                  {productionOrderItem.deliveredAt
                    ? timestampFormatter(productionOrderItem.deliveredAt)
                    : NOT_PROVIDED}
                </td>
                <td className="hidden py-4 pr-4 sm:table-cell">
                  {productionOrderItem.product.name}
                </td>
                <td className="hidden py-4 pr-4 text-right sm:table-cell">
                  {productionOrderItem.quantity}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </Card>
  );
}

ProductionOrdersShowItemDetails.propTypes = {
  productionOrder: PropTypes.object.isRequired,
};

export default ProductionOrdersShowItemDetails;
